export const SelectOptionsDataProcessor = (data, defaultValue) => {
  let newArr = [{ id: "", name: defaultValue }];
  for (let i = 0; i < data.length; i++) {
    newArr.push({ id: data[i].key, name: data[i].label });
  }
  return newArr;
};
